import React, { useEffect, useState } from "react";
import Handler from "../../Helpers/Components/Handler";

const TILES = [
    { key: "todayTotal", label: "New Today", icon: "fa-solid fa-user-plus", tone: "primary" },
    { key: "todayConverted", label: "Converted Today", icon: "fa-solid fa-circle-check", tone: "success" },
    { key: "todayRejected", label: "Rejected Today", icon: "fa-solid fa-circle-xmark", tone: "danger" },
    { key: "todayFollowUps", label: "Follow-ups Today", icon: "fa-solid fa-calendar-day", tone: "info" },
    // { key: "overdueFollowUps", label: "Overdue Follow-ups", icon: "fa-solid fa-triangle-exclamation", tone: "warning" },
    // { key: "totalLeads", label: "Total Leads", icon: "fa-solid fa-users", tone: "muted" },
];

const LeadStats = ({ onQuickFilter }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState(null);

    const getStats = async () => {
        setLoading(true);
        const response = await Handler({ method: "get", url: "/lead/stats" });
        if (response?.success) setStats(response?.data);
        else setStats(null);
        setLoading(false);
    };

    useEffect(() => {
        getStats();
    }, []);

    const values = {
        todayTotal: stats?.today?.total || 0,
        todayConverted: stats?.today?.converted || 0,
        todayRejected: stats?.today?.rejected || 0,
        todayFollowUps: stats?.today?.followUps || 0,
        overdueFollowUps: stats?.followUpsOverdue || 0,
        totalLeads: stats?.overall?.total || 0,
    };

    const conversionRate = stats?.overall?.total
        ? ((stats.overall.converted / stats.overall.total) * 100).toFixed(1)
        : "0.0";

    return (
        <div className="lead-stats mb-3">
            <div className="lead-stats-grid">
                {TILES.map((tile) => (
                    <div
                        className={`lead-stat-card tone-${tile.tone}${onQuickFilter ? " lead-stat-card-clickable" : ""}`}
                        key={tile.key}
                        role={onQuickFilter ? "button" : undefined}
                        style={onQuickFilter ? { cursor: "pointer" } : undefined}
                        onClick={() => onQuickFilter?.(tile.key)}
                        title={onQuickFilter ? `Filter leads: ${tile.label}` : undefined}
                    >
                        <div className="lead-stat-icon"><i className={tile.icon}></i></div>
                        <div className="lead-stat-info">
                            <span className="lead-stat-value">{loading ? "-" : values[tile.key]}</span>
                            <span className="lead-stat-label">{tile.label}</span>
                        </div>
                    </div>
                ))}
                {/* <div className="lead-stat-card tone-secondary">
                    <div className="lead-stat-icon"><i className="fa-solid fa-chart-line"></i></div>
                    <div className="lead-stat-info">
                        <span className="lead-stat-value">{loading ? "-" : `${conversionRate}%`}</span>
                        <span className="lead-stat-label">Overall Conversion Rate</span>
                    </div>
                </div> */}
            </div>
            {!loading && stats?.overall ? (
                <div className="lead-stats-breakdown">
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-primary"></i> Following: <b>{stats.overall.following || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-success"></i> Converted: <b>{stats.overall.converted || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-danger"></i> Rejected: <b>{stats.overall.rejected || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-dark"></i> Closed: <b>{stats.overall.closed || 0}</b></span>
                </div>
            ) : null}
        </div>
    );
};

export default LeadStats;
